import { AxiosInstance } from 'axios'

import { HttpService } from '../httpService'

export class AxiosApi implements HttpService {
  public api: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.api = instance
  }

  async get<T>(url: string, config?: any) {
    return (await this.api.get<T>(url, config)).data
  }

  async post<T, K>(url: string, body: K, config?: any) {
    return (await this.api.post<T>(url, body, config)).data
  }

  async put<T, K>(url: string, body: K, config?: any) {
    return (await this.api.put<T>(url, body, config)).data
  }

  async delete<T>(url: string, config?: any) {
    return (await this.api.delete<T>(url, config)).data
  }

  async patch<T, K>(url: string, body: K, config?: any) {
    return (await this.api.patch<T>(url, body, config)).data
  }
}
